var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('PreLoader'),_c('router-view'),_c('Cursor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }